import { render } from "./VideoFrame.vue?vue&type=template&id=db84c3ae&scoped=true"
import script from "./VideoFrame.vue?vue&type=script&lang=js"
export * from "./VideoFrame.vue?vue&type=script&lang=js"

import "./VideoFrame.vue?vue&type=style&index=0&id=db84c3ae&lang=scss&scoped=true"

import exportComponent from "/Users/oscarbout/Code/3birdhrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db84c3ae"]])

export default __exports__